import { Children, Fragment, type ReactNode } from 'react'

/**
 * Acronyms that must keep their casing when the category name is otherwise
 * lowercased for display (e.g. "Applying AI" → "applying AI", not "applying ai").
 */
const PRESERVED_ACRONYMS = new Set(['AI'])

/**
 * Renders the bold, lowercased category name used in the SubcatInterests title.
 * The whole label is lowercased via `mc-text--lowercase`, but any preserved
 * acronym token keeps its authored casing.
 */
export const QuizCategoryName = ({ children }: { children?: ReactNode }) => {
  const name = Children.toArray(children).join('')

  return (
    <b className='mc-text--bold mc-text-color--light mc-text--lowercase'>
      {name.split(' ').map((word, i) => (
        <Fragment key={`${word}-${i}`}>
          {i > 0 && ' '}
          {PRESERVED_ACRONYMS.has(word) ? (
            <span style={{ textTransform: 'none' }}>{word}</span>
          ) : (
            word
          )}
        </Fragment>
      ))}
    </b>
  )
}
